export interface AdviceSectionConfig {
  title: string;
  slug: string;
  metaTitle: string;
  metaDescription: string;
  description: string;
  heroGradient: string;
  subcategories: string[];
}

export const adviceSections: Record<string, AdviceSectionConfig> = {
  "buying-guides": {
    title: "Buying Guides",
    slug: "buying-guides",
    metaTitle: "Buying Guides | Expert Advice for Garden Equipment UK",
    metaDescription: "Expert buying guides for lawn mowers, chainsaws, generators, pressure washers and more. Make the right purchase decision with our detailed advice.",
    description: "Detailed buying guides to help you choose the right garden equipment. From lawn mowers and chainsaws to generators and pressure washers, we break down what matters most.",
    heroGradient: "bg-linear-to-br from-blue-50 to-indigo-50 dark:from-blue-950/20 dark:to-indigo-950/20",
    subcategories: ["Buying Guides", "Lawn Mowers", "Chainsaw", "Pressure Washers", "Leaf Blowers", "Scarifiers", "Cement Mixers", "Wood Chippers"],
  },
  "garden-care": {
    title: "Garden Care",
    slug: "garden-care",
    metaTitle: "Garden Care Advice | Lawns, Soil, Beds & More",
    metaDescription: "Expert garden care advice covering lawns, soil and composting, beds and borders, containers, feeding and watering. Keep your garden thriving year-round.",
    description: "Practical advice for maintaining a healthy, beautiful garden. From lawn care and soil improvement to feeding, watering, and keeping your beds and borders looking their best.",
    heroGradient: "bg-linear-to-br from-green-50 to-lime-50 dark:from-green-950/20 dark:to-lime-950/20",
    subcategories: ["Lawns", "Soil & Composting", "Beds & Borders", "Pots & Containers", "Planting Guides", "Pruning & Training", "Propagation"],
  },
  "garden-features": {
    title: "Garden Features",
    slug: "garden-features",
    metaTitle: "Garden Features | Ponds, Greenhouses, Fencing & More",
    metaDescription: "Advice on garden features including ponds, greenhouses, shade gardening, DIY projects and fencing. Transform your outdoor space with expert tips.",
    description: "Everything you need to know about adding and maintaining garden features. From ponds and greenhouses to fencing and DIY projects, get expert guidance for your outdoor space.",
    heroGradient: "bg-linear-to-br from-teal-50 to-emerald-50 dark:from-teal-950/20 dark:to-emerald-950/20",
    subcategories: ["Ponds", "Pond Care", "Shade Gardening", "Garden Design", "Garden Lighting", "Garden Paths", "Raised Beds", "Wildlife Gardening"],
  },
  "problem-solving": {
    title: "Problem Solving",
    slug: "problem-solving",
    metaTitle: "Garden Problem Solving | Weeds, Pests & Beginner Help",
    metaDescription: "Solutions for common garden problems including weeding, pest control, beginner mistakes and harvesting tips. Expert advice to keep your garden healthy.",
    description: "Practical solutions for the most common garden problems. Whether you're dealing with weeds, pests, or just starting out, find the expert advice you need.",
    heroGradient: "bg-linear-to-br from-amber-50 to-orange-50 dark:from-amber-950/20 dark:to-orange-950/20",
    subcategories: ["Pest & Problem Solving", "Pest Control", "Beginner Guides", "How To"],
  },
};
